/** Primary SL Logins table: Licensee, State, Website, Username, Password, Client, No Login */
export const PRIMARY_STATE_LOGINS_COLUMN_WIDTHS = [
  '14%',
  '6%',
  '17%',
  '14%',
  '14%',
  '14%',
  '21%',
] as const

/** Extra last column when at least one custom (+ Add) row can be removed. */
export const PRIMARY_STATE_LOGINS_COLUMN_WIDTHS_WITH_REMOVE = [
  '13%',
  '6%',
  '16%',
  '13%',
  '13%',
  '13%',
  '18%',
  '8%',
] as const

export const PRIMARY_STATE_LOGINS_GRID_TEMPLATE = PRIMARY_STATE_LOGINS_COLUMN_WIDTHS.join(' ')

/** New Login Wizard table (no No Login column). */
export const WIZARD_STATE_LOGINS_COLUMN_WIDTHS = ['18%', '8%', '20%', '17%', '17%', '20%'] as const
